import router from "@/router/index";
import config from "@/config/config";
import Cookies from "js-cookie";

const judegString = (val, flag = null) => {
	if (!val || !flag) return "";
	if (flag == 1) {
		//手机号隐藏*号
		let reg = /^(.{3}).*(.{4})$/;
		return val.replace(reg, "$1****$2");
	} else if (flag == 2) {
		//身份证号隐藏*号
		let reg = /^(.{4}).*(.{4})$/;
		return val.replace(reg, "$1****$2");
	} else if (flag == 3) {
		//姓名隐藏*号
		let name = "";
		if (val.length === 2) {
			name = val.substring(0, 1) + "*"; // 截取name 字符串截取第一个字符，
		} else if (val.length === 3) {
			name = val.substring(0, 1) + "*" + val.substring(2, 3); // 截取第一个和第三个字符
		} else if (val.length > 3) {
			name =
				val.substring(0, 1) +
				"**" +
				val.substring(val.length - 1, val.length); // 大于3个字只显示头尾中间用*号
		}
		return name;
	}
};

// 截取当前数据到小数点后两位
const numFilter = (val, fix = 2) => {
	if (val !== 0) {
		val = Number(val); // 字符串转为数字，目标数据为数字可不转
		val = "" + val.toFixed(2); // 保留两位小数并转为字符串
		let int = val.slice(0, fix * -1 - 1); // 获取整数
		let ext = val.slice(fix * -1 - 1); // 获取到小数
		int = int.split("").reverse().join(""); // 翻转整数
		let temp = ""; // 临时变量
		for (let i = 0; i < int.length; i++) {
			temp += int[i];
			if ((i + 1) % 3 === 0 && i !== int.length - 1) {
				temp += ","; // 每隔3个数字拼接一个逗号
			}
		}
		temp = temp.split("").reverse().join(""); // 加完逗号之后翻转
		temp = temp + ext; // 整数小数拼接
		return temp; // 返回
	} else {
		return val;
	}
};

// 判断类型集合
const checkStr = (str, type) => {
	switch (type) {
		case "mobile": //手机号码
			return /^1[0-9]{10}$/.test(str);
		case "tel": //座机
			return /^(0\d{2,3}-\d{7,8})(-\d{1,4})?$/.test(str);
		case "card": //身份证
			return /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(str);
		case "mobileCode": //6位数字验证码
			return /^[0-9]{6}$/.test(str);
		case "pwd": //密码以字母开头，长度在6~18之间，只能包含字母、数字和下划线
			return /^([a-zA-Z0-9_]){6,18}$/.test(str);
		case "payPwd": //支付密码 6位纯数字
			return /^[0-9]{6}$/.test(str);
		case "postal": //邮政编码
			return /[1-9]\d{5}(?!\d)/.test(str);
		case "QQ": //QQ号
			return /^[1-9][0-9]{4,9}$/.test(str);
		case "email": //邮箱
			return /^[\w-]+(\.[\w-]+)*@[\w-]+(\.[\w-]+)+$/.test(str);
		case "money": //金额(小数点2位)
			return /^\d*(?:\.\d{0,2})?$/.test(str);
		case "URL": //网址
			return /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/.test(
				str
			);
		case "IP": //IP
			return /((?:(?:25[0-5]|2[0-4]\\d|[01]?\\d?\\d)\\.){3}(?:25[0-5]|2[0-4]\\d|[01]?\\d?\\d))/.test(
				str
			);
		case "date": //日期时间
			return (
				/^(\d{4})\-(\d{2})\-(\d{2}) (\d{2})(?:\:\d{2}|:(\d{2}):(\d{2}))$/.test(
					str
				) || /^(\d{4})\-(\d{2})\-(\d{2})$/.test(str)
			);
		case "number": //数字
			return /^[0-9]$/.test(str);
		case "english": //英文
			return /^[a-zA-Z]+$/.test(str);
		case "chinese": //中文
			return /^[\\u4E00-\\u9FA5]+$/.test(str);
		case "lower": //小写
			return /^[a-z]+$/.test(str);
		case "upper": //大写
			return /^[A-Z]+$/.test(str);
		case "HTML": //HTML标记
			return /<("[^"]*"|'[^']*'|[^'">])*>/.test(str);
		default:
			return true;
	}
};

const checkMobile = () => {
	let flag = navigator.userAgent.match(
		/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
	);
	return flag;
};

const checkChooseName = (str, flag) => {
	let strArr = [];
	if (flag == 1) {
		strArr = ["", "上架", "待上架", "下架"];
	} else if (flag == 2) {
		strArr = ["否", "是"];
	} else if (flag == 3) {
		strArr = ["无效", "有效"];
	}
	return strArr[str];
};

const formatDate = (dateVal, formatType = "yyyy-MM-dd") => {
	let date = dateVal ? new Date(dateVal * 1000) : new Date();
	if (/(y+)/.test(formatType)) {
		formatType = formatType.replace(
			RegExp.$1,
			(date.getFullYear() + "").substr(4 - RegExp.$1.length)
		);
	}
	let o = {
		"M+": date.getMonth() + 1,
		"d+": date.getDate(),
		"h+": date.getHours(),
		"m+": date.getMinutes(),
		"s+": date.getSeconds(),
	};
	for (let k in o) {
		if (new RegExp(`(${k})`).test(formatType)) {
			let str = o[k] + "";
			formatType = formatType.replace(
				RegExp.$1,
				RegExp.$1.length === 1 ? str : ("00" + str).substr(str.length)
			);
		}
	}
	return formatType;
};

const getCurrentTime = (flag = null, dateVal = null) => {
	let str = new Date(dateVal ? dateVal / 1000000 : "");
	let year = str.getFullYear();
	let month = str.getMonth() + 1;
	let day = str.getDate();
	let hour = str.getHours();
	let min = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
	let sec = str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
	return flag == 1
		? year
		: flag == 2
		? year + "-" + month + "-" + day
		: year + "-" + month + "-" + day + " " + hour + ":" + min + ":" + sec;
};

const getUrl = (flag = null) => {
	if (flag == 1) {
		return location.href.split("?")[1];
	} else {
		let obj = {};
		let hrefs = location.href.split("?");
		if (hrefs[1]) {
			let keyValue = hrefs[1].split("&");
			if (keyValue) {
				for (let i = 0; i < keyValue.length; i++) {
					let item = keyValue[i].split("=");
					obj[item[0]] = item[1];
				}
			}
		}
		return obj;
	}
};

const getUrlParam = (name) => {
	if (!name) return false;
	var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
	var result = window.location.search.substr(1).match(reg);
	return result ? decodeURIComponent(result[2]) : null;
};

//打开新页面:type:0,不储存在浏览器路由中;1,储存
const openPage = (url, data, type = 1) => {
	if (type == 1) {
		router.push({
			path: url,
			query: data,
		});
	} else {
		router.replace({
			path: url,
			query: data,
		});
	}
};

const isDataNull = (text) => {
	//判断是否为空值
	if (
		text != "" &&
		text != null &&
		text != "null" &&
		text != undefined &&
		text.length != 0 &&
		Object.keys(text).length != 0
	) {
		return true;
	}
	return false;
};

/**
 * @returns {String} 当前浏览器名称
 */
const getExplorer = () => {
	const ua = window.navigator.userAgent;
	const isExplorer = (exp) => {
		return ua.indexOf(exp) > -1;
	};
	if (isExplorer("MSIE")) return "IE";
	else if (isExplorer("Firefox")) return "Firefox";
	else if (isExplorer("Chrome")) return "Chrome";
	else if (isExplorer("Opera")) return "Opera";
	else if (isExplorer("Safari")) return "Safari";
	else return "Other";
};

/**
 * 引入loading
 */
const getLoading = (obj) => {
	obj.$Spin.show({
		render: (h) => {
			return h("div", [
				h("Icon", {
					class: "demo-spin-icon-load",
					props: {
						type: "ios-loading",
						size: 18,
					},
				}),
				h("div", "数据加载中..."),
			]);
		},
	});
};

/**
 * 打印输出
 */
const consoleLog = (obj) => {
	if (config.consoleLogFlag) {
		console.log(obj);
	}
};

/**
 * msg提示信息
 */
const msg = (data, obj) => {
	if (data.msg) {
		obj.$message({
			message: data.msg,
			type: data.icon ?? "error",
		});
	}
};

/**
 * 获取窗口banner高度
 */
// const getClientHeight = () => {
// 	if (document.documentElement.clientWidth > 300) {
// 		return (
// 			Math.ceil((document.documentElement.clientWidth * 500) / 1920) +
// 			(checkMobile() ? 1 : "")
// 		);
// 	}
// };
const getClientHeight = () => {
	if (document.documentElement.clientWidth > 300) {
		return (
			Math.ceil((document.documentElement.clientWidth * 500) / 1920) +
			(checkMobile() ? 1 : "")
		);
	}
};

export const setCookies = (key, value, flag = null, expires = null) => {
	if (key && value) {
		if (flag == 1) {
			Cookies.set(key, JSON.stringify(value));
		} else {
			Cookies.set(key, JSON.stringify(value), {
				expires: expires || config.cookieExpires || 30,
			});
		}
	}
};
export const getCookies = (key) => {
	let data = key ? Cookies.get(key) || "" : "";
	return data ? JSON.parse(data) : "";
};
export const removeCookies = (key) => {
	key ? Cookies.remove(key) || "" : "";
};

export const setSession = (key, value) => {
	if (key && value) sessionStorage.setItem(key, JSON.stringify(value));
};
export const getSession = (key) => {
	return key ? JSON.parse(sessionStorage.getItem(key)) || "" : "";
};
export const removeSession = (key) => {
	key ? sessionStorage.removeItem(key) || "" : "";
};

export const setLocal = (key, value) => {
	if (key && value) localStorage.setItem(key, JSON.stringify(value));
};
export const getLocal = (key) => {
	let data = key ? localStorage.getItem(key) || "" : "";
	return data ? JSON.parse(data) : "";
};
export const removeLocal = (key) => {
	key ? localStorage.removeItem(key) || "" : "";
};

export default {
	judegString,
	numFilter,
	checkStr,
	checkMobile,
	checkChooseName,
	formatDate,
	getCurrentTime,
	getUrl,
	getUrlParam,
	openPage,
	isDataNull,
	getExplorer,
	getLoading,
	consoleLog,
	getClientHeight,
	msg,
};
